import React from 'react';

const DoneIcon = ({ color, height, width }) => {
  return (
    <svg fill={color} height={height} viewBox="0 0 24 24" width={width}>
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
    </svg>
  );
};

export default DoneIcon;



// WEBPACK FOOTER //
// ./src/IconDone.js